import { render, staticRenderFns } from "./RDPV.vue?vue&type=template&id=2d3b4d60&scoped=true"
import script from "./RDPV.vue?vue&type=script&lang=js"
export * from "./RDPV.vue?vue&type=script&lang=js"
import style0 from "./RDPV.vue?vue&type=style&index=0&id=2d3b4d60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d3b4d60",
  null
  
)

export default component.exports